<script setup lang="ts">
import usuarioSelect from '~/graphql/usuarioSelect.graphql';
import { CompromissoForm } from '~/lib/fw';

interface Props {
  pastaCodigos?: string[];
}

const props = defineProps<Props>();
const emit = defineEmits(['close']);
</script>

<template>
  <CompromissoForm
    action="alteracao-responsavel-negocial/alterar-responsavel-negocial"
    :pasta-codigos="props.pastaCodigos ?? []"
    :wait-for-result="true"
    :show-upload-files="false"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Responsável"
        name="responsavel"
        :rules="[
          {
            message: 'Responsável é obrigatório',
            required: true,
            trigger: 'change',
            type: 'object',
          },
        ]"
      >
        <GqlSelect
          v-model:value="model.responsavel"
          :query="usuarioSelect"
          placeholder="Selecione o responsável"
          :variables="{
            where: {
              ativo: {
                eq: true,
              },
            },
            order: [
              {
                nome: 'ASC',
              },
            ],
          }"
        />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
